module.exports = __webpack_public_path__ + "img/MT.eaa2e701.svg";